<div class="message-container warning-fill text-centered p-3">
  <div class="header w-100 text-center mb-3">
    <mwp-text-translate text="Not Configured!" jsonKey="notConfigured" />
  </div>
  <div class="message-box mb-3">
    <div>
      <mwp-text-translate text="Wizard Type:" jsonKey="wizardType" />
      {{ errorWizardName }}
    </div>
    <div>
      <mwp-text-translate text="Panel:" jsonKey="panel" />
      {{ errorPanelName }}
    </div>
    <div>
      <mwp-text-translate text="Benefit Name:" jsonKey="benefitName" />
      {{ errorBenefitName }}
    </div>
    <div>
      <mwp-text-translate text="Please notify administrator of this error as you will not be able to continue this benefit selection. Take a screen shot or mention the panel and benefit name." jsonKey="wizardErrorNote" />
    </div>
  </div>
  @if (displayReturnButton) {
    <div class="d-flex justify-content-center">
      <button class="mwp-button" (click)="cancelWizard()">
        <mwp-text-translate text="Back To Category Selection" jsonKey="backToCategorySelection" />
      </button>
    </div>
  }
</div>